import { AddNoticePayload } from "@/data/payload/notice/add-notice-payload";
import { NoticeRepository } from "@/domain/repository/notice-repository";
import { NoticeType } from "@/utils/enum/notice-type-enum";
import { SATError, SATResult } from "@sadtx/sat-error";

export class AddNoticeUsecase {
  constructor(private readonly noticeRepository: NoticeRepository) {}

  async execute(
    title: string,
    markdownContent: string,
    startDate: string,
    endDate: string,
    majorVersion: string,
    minorVersion: string,
    patchVersion: string,
    buildNumber: string,
    isImportant: boolean
  ): Promise<SATResult<void, SATError>> {
    const payload: AddNoticePayload = {
      title,
      body: markdownContent,
      type: NoticeType.Update,
      startViewDate: startDate,
      endViewDate: endDate,
      appVersion: `v${majorVersion}.${minorVersion}.${patchVersion}(${buildNumber})`,
      isPriority: isImportant,
      boardTitle: "ko",
      priorityNumber: 0,
    };

    const result = await this.noticeRepository.addNotice(payload);

    if (result.isSuccess) {
      console.log("[AddNoticeUsecase] :: execute :: 공지사항 등록 성공");
      return SATResult.success(undefined);
    }

    console.log("[AddNoticeUsecase] :: execute :: 공지사항 등록 실패", result.error);
    return SATResult.failure(result.error);
  }
}
